module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('empty-reminder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.records.length == 0 && !_vm.loading),
      expression: "records.length == 0 && !loading"
    }]
  }), _vm._v(" "), _c('div', _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "record"
    }, [_c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(_vm.getDescription(record.nickname, record.status)))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.$t('time')) + _vm._s(_vm.$t(':')) + _vm._s(_vm._f("createFormatTime")(record.created_at, record.created_at)))])])
  }), 0), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('load-more', {
    attrs: {
      "current-page": _vm.currentPage,
      "total-page": _vm.totalPage,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getFriendRecords($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bba553ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/friendRecords/FriendRecordsM.vue
// module id = 1385
// module chunks = 1